import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { logo } from '../../Data/Images/Home';
import Language from '../../Layout/Header/Language';
import { useLazyGetOrderBySessionQuery, useMetaApiMutation } from '../../features/metaApiSlice';
import CustomLink from '../CustomLink';
import { v4 as uuidv4 } from 'uuid';
import { getValidFbParam, getMetaParamsAfterRedirect } from '../../utils';
import { useTranslation } from 'react-i18next';
import useOrderLookupRetry from '../../hooks/useOrderLookupRetry';

const SmartFormulaOrderComplete = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  const [getOrderBySession] = useLazyGetOrderBySessionQuery();
  const [metaApi] = useMetaApiMutation();

  const handleOrderFound = React.useCallback(
    async (order) => {
      const orderId = order?.id;
      if (!orderId) return;

      const eventsSentKey = `order_events_sent_${orderId}`;
      if (localStorage.getItem(eventsSentKey) === 'true') {
        console.log('Events already sent for order:', orderId);
        return;
      }

      const id = uuidv4();
      const email =
        (order.user?.email || localStorage.getItem('email') || '').trim().toLowerCase() || undefined;
      const metaParams = getMetaParamsAfterRedirect();
      const external_id = metaParams.externalId;
      const fbp = getValidFbParam(metaParams.fbp);
      const fbc = getValidFbParam(metaParams.fbc);
      const event_source_url = window.location.origin + window.location.pathname;

      if (window.fbq) {
        window.fbq(
          'track',
          'Purchase',
          {
            currency: 'EUR',
            value: order.discounted_price,
          },
          {
            eventID: id,
          },
        );
      }

      try {
        await metaApi({
          event_name: 'Purchase',
          id,
          orderId,
          currency: 'EUR',
          value: order.discounted_price,
          email,
          page: window.location.href,
          external_id,
          fbp,
          fbc,
          event_source_url,
        }).unwrap();
      } catch (err) {
        console.log('Error sending Meta Purchase event:', err);
      }

      localStorage.setItem(eventsSentKey, 'true');
    },
    [metaApi],
  );

  const lookupOrder = React.useCallback(
    () => getOrderBySession(sessionId),
    [getOrderBySession, sessionId],
  );

  useOrderLookupRetry({
    isEnabled: Boolean(sessionId),
    lookup: lookupOrder,
    onOrderFound: handleOrderFound,
    lookupLabel: `stripe-session:${sessionId}`,
  });

  return (
    <>
      <div className="t-sticky t-top-0 t-z-10 t-w-full t-bg-secondary t-flex t-items-center t-justify-center t-py-2">
        <div className="container t-flex t-items-center t-justify-center">
          <img src={logo} alt="" width={60} />
          <div className="t-ml-auto">
            <Language />
          </div>
        </div>
      </div>
      <div className="t-w-full t-h-[80vh] product-suggestion-section section-padding t-flex t-flex-col t-items-center t-justify-center t-gap-4">
        <h2 className="text-center">{t('OrderComplete_Title')}</h2>

        <h4 className="text-center">{t('OrderComplete_ThankYou')}</h4>
        <CustomLink
          to={'/'}
          className="!t-text-sm !t-text-capitalize btn-custom-quaternary !t-px-8 t-py-2 !t-bg-secondary disabled:!t-bg-quaternary hover:!t-text-white"
        >
          <h6 className="text-center t-m-0">{t('OrderComplete_GoHome')}</h6>
        </CustomLink>
      </div>
    </>
  );
};

export default SmartFormulaOrderComplete;
